function cabinetTitle(value) {
  const entities = {amp:'&',quot:'"',apos:"'",ndash:'–',mdash:'—',Prime:'″',prime:'′',nbsp:' '};
  return String(value || '').replace(/&(#x[0-9a-f]+|#[0-9]+|amp|quot|apos|ndash|mdash|Prime|prime|nbsp);/gi, (match, code) => {
    if (code[0] !== '#') return entities[code] || match;
    const point = code[1].toLowerCase() === 'x' ? parseInt(code.slice(2), 16) : Number(code.slice(1));
    return point > 0 && point <= 0x10ffff ? String.fromCodePoint(point) : match;
  });
}
function updateGallerySelection(root, url) {
  const thumbnails = [...root.querySelectorAll('[data-gallery-image]')];
  const selectedPath = new URL(url, location.href).pathname;
  let index = -1;
  thumbnails.forEach((thumbnail, i) => {
    const selected = new URL(thumbnail.href).pathname === selectedPath;
    if (selected) { thumbnail.setAttribute('aria-current', 'true'); index = i; }
    else thumbnail.removeAttribute('aria-current');
  });
  const counter = root.querySelector('[data-gallery-position]');
  if (counter) counter.textContent = index >= 0 ? (index + 1) + ' / ' + thumbnails.length : '';
}
function setGalleryPhoto(root, url) {
  const main = root.querySelector('[data-product-image]');
  main.src = url;
  main.removeAttribute('srcset');
  root.querySelector('.product-main-image').href = url;
  updateGallerySelection(root, url);
}
class CabinetPurchase extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.form = this.querySelector('form');
    this.submit = this.querySelector('[name="add"]');
    this.quantity = this.querySelector('[name="quantity"]');
    this.status = this.querySelector('.purchase-status');
    this.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) this.selectVariant();
    });
    this.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {
      if (Number(button.dataset.quantity) > 0) this.quantity.stepUp(); else this.quantity.stepDown();
    }));
    this.form.addEventListener('submit', event => this.addToCart(event));
  }
  selectVariant() {
    const values = [...this.querySelectorAll('[data-option-index]')].map(group => group.querySelector('input:checked')?.value);
    const variant = this.variants.find(item => item.options.every((value, i) => value === values[i]));
    this.submit.disabled = Boolean(this.pending) || !variant?.available;
    this.submit.textContent = variant ? (variant.available ? 'Add to cart' : 'Sold out') : 'Unavailable';
    this.status.textContent = variant ? '' : 'This combination is unavailable. Choose another option.';
    this.form.elements.id.value = variant?.id || '';
    if (!variant) return;
    this.querySelector('[data-price]').textContent = variant.price;
    const compare = this.querySelector('[data-compare]');
    compare.textContent = variant.compare || '';
    compare.hidden = !variant.compare;
    this.querySelector('[data-sku]').textContent = variant.sku || '—';
    this.quantity.min = variant.min;
    this.quantity.step = variant.step;
    if (variant.max) this.quantity.max = variant.max; else this.quantity.removeAttribute('max');
    this.quantity.value = variant.min;
    const scope = this.closest('.product-detail') || this.closest('.product-card');
    const sale = scope?.querySelector('[data-sale-badge]');
    if (sale) { sale.textContent = '-' + variant.discount + '%'; sale.hidden = !variant.discount; }
    const image = scope?.querySelector('[data-product-image]');
    if (image && variant.image) { image.src = variant.image; image.removeAttribute('srcset'); }
    const card = this.closest('.product-card');
    if (card) {
      card.querySelectorAll('.product-card-image, h2 a').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('variant', variant.id);
        link.href = url.href;
      });
    }
    if (this.hasAttribute('data-detail')) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      const zoom = scope.querySelector('.product-main-image');
      if (zoom && variant.image) { zoom.href = variant.image; updateGallerySelection(scope.querySelector('.product-gallery'), variant.image); }
    }
  }
  async addToCart(event) {
    event.preventDefault();
    if (this.pending || !this.form.reportValidity() || this.submit.disabled) return;
    this.pending = true;
    this.submit.disabled = true;
    this.status.textContent = 'Adding…';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',body:new FormData(this.form),headers:{Accept:'application/json'}});
      const item = await response.json();
      if (!response.ok) throw new Error(item.description || 'Could not add this item. Please try again.');
      this.status.textContent = 'Added to your cart.';
      const drawer = document.querySelector('#CartConfirmation');
      if (drawer) {
        drawer.querySelector('[data-added-title]').textContent = cabinetTitle(item.product_title || item.title);
        drawer.querySelector('[data-added-variant]').textContent = item.variant_title === 'Default Title' ? '' : item.variant_title || '';
        drawer.querySelector('[data-added-quantity]').textContent = 'Quantity: ' + item.quantity;
        const itemAmount = drawer.querySelector('[data-added-line-price]');
        itemAmount.hidden = typeof item.final_line_price !== 'number';
        itemAmount.textContent = itemAmount.hidden ? '' : 'Item total: ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:drawer.dataset.currency}).format(item.final_line_price / 100);
        drawer.querySelector('[data-cart-summary]').hidden = true;
        const image = drawer.querySelector('img');
        image.hidden = !item.image;
        if (item.image) {const addedVariant = this.variants.find(variant => String(variant.id) === String(item.variant_id || item.id)); image.src=addedVariant?.image || this.dataset.cleanImage || item.image;image.alt=cabinetTitle(item.product_title || item.title);}
        drawer.showModal();
      }
      try {
        const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'}});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          if (drawer) {
            drawer.querySelector('[data-cart-subtotal]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:cart.currency}).format(cart.total_price / 100);
            drawer.querySelector('[data-cart-summary]').hidden = false;
          }
          document.querySelectorAll('[data-cart-count]').forEach(badge => {
            badge.textContent = cart.item_count;
            badge.setAttribute('aria-label', cart.item_count + ' items in cart');
          });
          const link = document.querySelector('.cart-link');
          if (link) link.textContent = 'Cart (' + cart.item_count + ') ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:cart.currency}).format(cart.total_price / 100);
        }
      } catch (_) { /* The confirmed add remains valid if the count refresh fails. */ }
    } catch (error) { this.status.textContent = error.message; }
    finally {
      this.pending = false;
      const selected = this.variants.find(variant => String(variant.id) === this.form.elements.id.value);
      this.submit.disabled = !selected?.available;
    }
  }
}
customElements.define('cabinet-purchase', CabinetPurchase);
document.addEventListener('click', event => {
  const close = event.target.closest('[data-close-cart]');
  if (close) close.closest('dialog').close();
  const thumbnail = event.target.closest('[data-gallery-image]');
  if (thumbnail) {
    event.preventDefault();
    const root = thumbnail.closest('.product-gallery');
    setGalleryPhoto(root, thumbnail.href);
  }
});

if (!customElements.get('series-details')) {
  customElements.define('series-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.activate(next); this.tabs[next].focus(); }
        });
      });
    }
    activate(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = i !== index;
      });
    }
  });
}

const cabinetNavigation = document.querySelector('.catalog-nav');
if (cabinetNavigation) {
  cabinetNavigation.querySelectorAll('details').forEach(menu => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      cabinetNavigation.querySelectorAll('details[open]').forEach(other => {
        if (other !== menu && !other.contains(menu) && !menu.contains(other)) other.open = false;
      });
    });
  });
  document.addEventListener('click', event => {
    if (!cabinetNavigation.contains(event.target) || event.target.closest('a[href]')) cabinetNavigation.querySelectorAll('details[open]').forEach(menu => menu.open = false);
  });
  cabinetNavigation.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('details[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); event.preventDefault(); }
  });
}

const cabinetGallery = document.querySelector('.product-gallery');
const imageViewer = document.querySelector('.product-image-viewer');
if (cabinetGallery && imageViewer) {
  const photos = [...cabinetGallery.querySelectorAll('[data-gallery-image]')];
  updateGallerySelection(cabinetGallery, cabinetGallery.querySelector('.product-main-image').href);
  cabinetGallery.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => {
    if (!photos.length) return;
    const currentPath = new URL(cabinetGallery.querySelector('.product-main-image').href).pathname;
    const currentIndex = photos.findIndex(photo => new URL(photo.href).pathname === currentPath);
    const nextIndex = ((currentIndex < 0 ? 0 : currentIndex) + Number(button.dataset.galleryStep) + photos.length) % photos.length;
    setGalleryPhoto(cabinetGallery, photos[nextIndex].href);
  }));
  let photoIndex = 0;
  const showPhoto = index => {
    photoIndex = (index + photos.length) % photos.length;
    const photo = photos[photoIndex];
    if (!photo) return;
    const image = imageViewer.querySelector('img');
    image.src = photo.href;
    image.alt = photo.querySelector('img')?.alt || document.querySelector('.product-detail h1').textContent;
    imageViewer.querySelector('[data-image-counter]').textContent = (photoIndex + 1) + ' / ' + photos.length;
  };
  cabinetGallery.querySelector('.product-main-image')?.addEventListener('click', event => {
    if (!photos.length) return;
    event.preventDefault();
    const mainURL = new URL(event.currentTarget.href);
    const index = photos.findIndex(photo => new URL(photo.href).pathname === mainURL.pathname);
    if (index >= 0) showPhoto(index);
    else {imageViewer.querySelector('img').src=event.currentTarget.href;imageViewer.querySelector('img').alt=cabinetGallery.querySelector('[data-product-image]').alt;imageViewer.querySelector('[data-image-counter]').textContent='';}
    imageViewer.showModal();
  });
  imageViewer.querySelector('[data-image-close]').addEventListener('click', () => imageViewer.close());
  imageViewer.querySelector('[data-image-previous]').addEventListener('click', () => showPhoto(photoIndex - 1));
  imageViewer.querySelector('[data-image-next]').addEventListener('click', () => showPhoto(photoIndex + 1));
  imageViewer.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') {event.preventDefault();showPhoto(photoIndex - 1);}
    if (event.key === 'ArrowRight') {event.preventDefault();showPhoto(photoIndex + 1);}
  });
}

const returnToCatalog = document.querySelector('[data-return-to-catalog]');
if (returnToCatalog && document.referrer) {
  try {
    const previous = new URL(document.referrer);
    const root = window.Shopify?.routes?.root || '/';
    if (previous.origin === location.origin &&
        (previous.pathname.startsWith(root + 'collections/') || previous.pathname === root + 'search')) {
      returnToCatalog.href = previous.href;
    }
  } catch (_) { /* Keep the series link when the referrer cannot be used. */ }
}

const mobileNavigation = document.querySelector('.mobile-menu');
if (mobileNavigation) {
  document.addEventListener('click', event => {
    if (!mobileNavigation.contains(event.target) || event.target.closest('a')) mobileNavigation.open = false;
  });
  mobileNavigation.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      mobileNavigation.open = false;
      mobileNavigation.querySelector('summary').focus();
      event.preventDefault();
    }
  });
}

const cartForm = document.querySelector('[data-cart-form]');
if (cartForm) {
  let updating = false;
  cartForm.addEventListener('submit', async event => {
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    if (updating || !cartForm.reportValidity()) return;
    updating = true;
    const quantityInputs = [...cartForm.querySelectorAll('[data-line-key]')];
    quantityInputs.forEach(input => input.readOnly = true);
    cartForm.setAttribute('aria-busy', 'true');
    const status = cartForm.querySelector('[data-cart-status]');
    const buttons = [...cartForm.querySelectorAll('button[type="submit"]')];
    buttons.forEach(button => button.disabled = true);
    status.textContent = 'Updating your cart…';
    try {
      const updates = Object.fromEntries([...cartForm.querySelectorAll('[data-line-key]')].map(input => [input.dataset.lineKey, Number(input.value)]));
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({updates})
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || 'Could not update your cart. Please try again.');
      status.textContent = 'Cart updated.';
      location.reload();
    } catch (error) {
      status.textContent = error.message;
      updating = false;
      quantityInputs.forEach(input => input.readOnly = false);
      cartForm.removeAttribute('aria-busy');
      buttons.forEach(button => button.disabled = false);
    }
  });
}

// Match the source catalog: selecting an order immediately refreshes page one.
document.querySelectorAll('.catalog-controls select[name="sort_by"]').forEach(select => {
  select.addEventListener('change', () => select.form.requestSubmit());
});
